(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-row"] && !Shopify.designMode) return;
  try {
    function closeTenniseaMenu(dialog) {
  if (!dialog || !dialog.open || dialog.dataset.closing === 'true') return;
  dialog.dataset.closing = 'true';
  dialog.classList.remove('tn-mobile-menu__panel--visible');
  const finish = () => {
    dialog.close();
    delete dialog.dataset.closing;
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
  else window.setTimeout(finish, 340);
}
document.addEventListener('click', function (event) {
  const opener = event.target.closest('[data-tn-menu-open]');
  if (opener) {
    const dialog = opener.parentElement.querySelector('.tn-mobile-menu__panel');
    if (dialog && !dialog.open) {
      dialog.showModal();
      window.requestAnimationFrame(() => dialog.classList.add('tn-mobile-menu__panel--visible'));
    }
    return;
  }
  const closer = event.target.closest('.tn-mobile-menu__close');
  if (closer) {
    event.preventDefault();
    closeTenniseaMenu(closer.closest('dialog'));
  } else if (event.target.matches('.tn-mobile-menu__panel')) {
    closeTenniseaMenu(event.target);
  }
});
document.addEventListener('cancel', function (event) {
  if (event.target.matches('.tn-mobile-menu__panel')) {
    event.preventDefault();
    closeTenniseaMenu(event.target);
  }
}, true);
let tenniseaSwipeStart = null;
document.addEventListener('touchstart', function (event) {
  const dialog = event.target.closest('.tn-mobile-menu__panel');
  if (!dialog || !dialog.open || event.touches.length !== 1) return;
  tenniseaSwipeStart = { dialog, x: event.touches[0].clientX, y: event.touches[0].clientY };
}, { passive: true });
document.addEventListener('touchend', function (event) {
  if (!tenniseaSwipeStart || event.changedTouches.length !== 1) return;
  const dx = event.changedTouches[0].clientX - tenniseaSwipeStart.x;
  const dy = event.changedTouches[0].clientY - tenniseaSwipeStart.y;
  if (dx < -65 && Math.abs(dx) > Math.abs(dy) * 1.3) closeTenniseaMenu(tenniseaSwipeStart.dialog);
  tenniseaSwipeStart = null;
}, { passive: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tennisea-mobile-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  const opener = event.target.closest('[data-tennisea-open]');
  if (opener) {
    const panel = opener.parentElement.querySelector('.tennisea-mobile-nav__panel');
    if (panel && !panel.open) panel.showModal();
  }
  if (event.target.matches('.tennisea-mobile-nav__panel')) event.target.close();
});
  } catch(e) { console.error(e); }
})();

})();
